import { useEffect } from "react";
import { appendChatBotSnippet, removeChatBotSnippet } from "../chatbotLoader";

type ChatBotHookConfig = {
  firstName: string;
  lastName: string;
  email: string;
  integrationKey: string;
  platformName: string;
  messageId: string;
  secretUrl: string;
  disabled?: boolean;
};

export function useChatBotSnippet({
  firstName,
  lastName,
  email,
  integrationKey,
  platformName,
  messageId,
  secretUrl,
  disabled = false,
}: ChatBotHookConfig) {
  useEffect(() => {
    appendChatBotSnippet({
      firstName,
      lastName,
      email,
      integrationKey,
      platformName,
      messageId,
      secretUrl,
      disabled,
    });

    return () => {
      removeChatBotSnippet();
    };
  }, [firstName, lastName, email, integrationKey, platformName, messageId, secretUrl, disabled]);
}
